import React, { useState, useEffect } from 'react'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { useHistory } from 'react-router-dom'
import { doneLoading, startLoading } from '../../utils/loading'
import { getRedirectPageUrl } from '../../redux/actions/redirectLink'
import { sessionSetItemObj, sessionSetItemStr } from '../../utils/sessionHelpers'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import { Button, Row } from 'rsuite'
import pathname from '../../constants/pathname'

export default function RedirectLink() {
  let history = useHistory()

  const [error, setError] = useState()

  const urlParams = new URLSearchParams(window.location.search)
  const type = urlParams.get('type')
  const id = urlParams.get('id')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    startLoading()
    try {
      const response = await getRedirectPageUrl(type, id)
      // console.log('response => ', response)

      if (response) {
        if (response?.datas?.length > 0) {
          response.datas.map((item) => {
            if (typeof item.values === 'object') {
              sessionSetItemObj(item.dataKey, item.values)
            } else {
              sessionSetItemStr(item.dataKey, item.values)
            }
          })
        }

        if (response?.redirectPath) {
          setTimeout(() => {
            history.push({
              pathname: `${response.redirectPath}`,
            })
          }, 3000)
        }
      }
    } catch (e) {
      // console.log('error', e?.response?.data)
      if (e?.response?.data) {
        setError({
          statusCode: 404,
          errorMessage: e.response.data?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
  }

  if (error) {
    return (
      <div className="custom-dashboard">
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
        <Row style={{ textAlign: 'center', marginTop: 20 }}>
          <Button
            style={{ minWidth: 250 }}
            onClick={(e) => {
              window.location.href = pathname.dashboardRoot
              window.opener = null
            }}
            appearance="primary"
          >
            กลับสู่หน้าหลัก
          </Button>
        </Row>
      </div>
    )
  }

  return (
    <>
      <div className="custom-dashboard">
        <PanalLoadingTemplate />

        <OverlayLoader />
      </div>
    </>
  )
}
